import _ from 'lodash';
import * as ActionType from '../../constants/actionType';
import {SerialDilutionAction} from '../../constants/actionType';

export function addSdCard(cardId, cardName, cardType) {
  return {type: ActionType.ADD_SD_CARD, cardId, cardName, cardType};
}

export function addSdRawTask(cardId, tasks) {
  return {type: ActionType.ADD_SD_RAW_TASK, cardId, tasks};
}

export function addSdRawTasksDiluentTarget(cardId, tasks) {
  return {type: ActionType.ADD_SD_RAW_TASKS_DILUENT_TARGET, cardId, tasks};
}

export function removeSdRawTask(cardId, taskId) {
  return {type: ActionType.REMOVE_SD_RAW_TASK, cardId, taskId};
}

export function removeDiluentTargetRawTask(cardId, taskId) {
  return {type: ActionType.REMOVE_SD_DILUENT_TARGET_RAW_TASK, cardId, taskId};
}

export function setIgnoredSdRawTask(cardId, taskId, isIgnored) {
  return {type: ActionType.SET_IGNORE_SD_RAW_TASK, cardId, taskId, isIgnored};
}

export function restoreCardSdRawTaskStateById(cardId, task) {
  return {type: ActionType.RESTORE_CARD_SDRAWTASKSTATE_BY_ID, cardId, task};
}

export function restoreCardSdRawTask(cardId, sdRawTasks) {
  return {type: ActionType.RESTORE_CARD_SDRAWTASKSTATE, cardId, sdRawTasks};
}

export function setSdRawTasksSummarySampleSource(cardId, task) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const {cards} = cardState;
    const prevTaskId = cards[cardId]?.sdRawTasksSummary?.taskSampleSource;

    if (_.isNumber(prevTaskId)) {
      dispatch(removeSdRawTask(cardId, prevTaskId));
    }

    dispatch({type: ActionType.SET_SD_RAW_TASK_SUMMARY_SAMPLE_SOURCE, cardId, task});
  };
}

export function setSdRawTasksSummarySampleTarget(cardId, tasks) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const {cards} = cardState;
    const prevTaskIds = cards[cardId]?.sdRawTasksSummary?.taskSampleTarget;

    if (prevTaskIds?.length) {
      dispatch(removeSdRawTask(cardId, prevTaskIds));
    }

    dispatch({type: ActionType.SET_SD_RAW_TASK_SUMMARY_SAMPLE_TARGET, cardId, tasks});
  };
}

export function setSdRawTasksSummaryDiluentSource(cardId, task) {
  return (dispatch, getState) => {
    const {cardState} = getState();
    const {cards} = cardState;
    const prevTaskId = cards[cardId]?.sdRawTasksSummary?.taskDiluentSource;

    if (_.isNumber(prevTaskId)) {
      dispatch(removeSdRawTask(cardId, prevTaskId));
    }
    dispatch({type: ActionType.SET_SD_RAW_TASK_SUMMARY_DILUENT_SOURCE, cardId, task});
  };
}

export function setSdRawTasksSummaryDiluentTargets(cardId, tasks) {
  return {type: ActionType.SET_SD_RAW_TASK_SUMMARY_DILUENT_TARGETS, cardId, tasks};
}

export function setSdRawTasksSummary(cardId, rawSummary) {
  return {type: SerialDilutionAction.SET_SD_RAW_TASKS_SUMMARY, cardId, rawSummary};
}

export function setCardSdProperty(cardId, sdProperty) {
  return {
    type: ActionType.SET_CARD_SD_PROPERTY,
    cardId,
    sdProperty,
  };
}

export function setSdPropertyObject(cardId, newValue) {
  return {
    type: ActionType.SET_SD_PROPERTY_OBJECT,
    cardId,
    newValue,
  };
}

// accepts array || object for newValue param and
// accepts array || number for stepNumber param
// to handle multiple changes in property object
export function setSdStepPropertiesObject(cardId, stepNumber, newValue) {
  return {
    type: ActionType.SET_SD_STEP_PROPERTIES_OBJECT,
    cardId,
    stepNumber,
    newValue,
  };
}

export function removeSdPropertyObject(cardId, sdPropertyObjectKey) {
  return {
    type: ActionType.REMOVE_SD_PROPERTY_OBJECT,
    cardId,
    sdPropertyObjectKey,
  };
}

export function setSdRawTaskIsSelected(cardId, taskId, isSelected) {
  return {
    type: ActionType.SET_SD_RAW_TASK_IS_SELECTED,
    cardId,
    taskId,
    isSelected,
  };
}

export function setSdReplicateWell(cardId, replicateWell) {
  return {
    type: ActionType.SET_SD_REPLICATE_WELL,
    cardId,
    replicateWell,
  };
}
